module.exports = __webpack_public_path__ + "static/media/buyNowPopUpPaidCard.cedb95e4.svg";